import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { QuotesRoutes } from "./Constants/routes";

const Quotes = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {QuotesRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/quotes" />
      </Switch>
    </>
  );
};

export default Quotes;

